import React from "react";
import Layout from "../components/layout/MainLayout";

const PerformanceReport = () => {

  return (
    <Layout>

      <h2>Performance Report</h2>

      <table border="1" cellPadding="10">

        <thead>
          <tr>
            <th>Month</th>
            <th>Deals Closed</th>
            <th>Revenue</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>March</td>
            <td>10</td>
            <td>2,00,000</td>
          </tr>
        </tbody>

      </table>

    </Layout>
  );
};

export default PerformanceReport;